import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface ReviewOfEstimatesForManagementBiasInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function ReviewOfEstimatesForManagementBiasInternalControls({ onBack, setActiveSection, controlsListSection }: ReviewOfEstimatesForManagementBiasInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Review of Estimates for Management Bias"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}
